import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Form, Modal, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import ImageFileUpload from "../../components/ImageFileUpload";
import ConsignmentImageKind from "../../enums/ConsignmentImageKind";
import React, { useState } from "react";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import { FileImageOutlined } from "@ant-design/icons";
const ConsignmentImageEditModal = (props) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fileUploadId, setFileUploadId] = useState(null);
    const [form] = useForm();
    const onFinish = (formValues) => {
        if (!fileUploadId) {
            setErrorMessage('Please upload a photo');
            return;
        }
        setLoading(true);
        axios.post(`/admin/v1/consignments/${props.consignmentId}/images`, {
            kind: formValues.imageKing,
            comments: formValues.comments,
            uploadFileId: fileUploadId
        }).then(() => {
            props.onImageUpdated();
            form.resetFields();
        }).catch((error) => {
            axiosErrorHandler(error, setErrorMessage);
        }).finally(() => {
            setLoading(false);
        });
    };
    return (_jsxs(Modal, { open: props.open, onOk: form.submit, onCancel: props.onCancel, confirmLoading: loading, title: "Add a Photo", destroyOnHidden: true, children: [_jsxs(Form, { form: form, onFinish: onFinish, children: [_jsx(Form.Item, { name: "imageKing", label: "Photo Type", rules: [
                            { required: true }
                        ], children: _jsx(Select, { options: ConsignmentImageKind.filtersArray() }) }), _jsx(Form.Item, { name: 'comments', label: 'Comments', children: _jsx(TextArea, {}) }), _jsx(ImageFileUpload, { onUploadComplete: setFileUploadId, icon: _jsx(FileImageOutlined, {}) })] }), errorMessage &&
                _jsx("div", { style: { marginTop: "20px" }, children: _jsx(Alert, { type: "error", title: errorMessage, banner: true }) })] }));
};
export default ConsignmentImageEditModal;
